import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

// Stores whose Ring AIR buy page hides the bling, charger, engraving and power
// plug steps (trade-in stays) and skips the review-cart upsell modal (add to
// cart opens the drawer directly).
export const RING_AIR_LEAN_BUY_FLOW_STORES = new Set<ShopifyStore>([
  ShopifyStore.IN,
]);

export const isRingAirLeanBuyFlow = (store?: ShopifyStore | null): boolean =>
  !!store && RING_AIR_LEAN_BUY_FLOW_STORES.has(store);
